import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { MessageCircle, Flame } from "lucide-react";

const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=15874073024&text=Hi%20Garage%20Kings!%20%F0%9F%91%91%20I%27d%20like%20to%20claim%20the%2015%25%20OFF%20launch%20offer%20for%20premium%20epoxy%20%2F%20polyaspartic%20garage%20flooring.";

export const EpoxyPromoBanner = ({ className = "" }: { className?: string }) => (
  <section className={`bg-background py-6 md:py-8 ${className}`}>
    <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.5 }}
        className="relative mx-auto max-w-6xl overflow-hidden rounded-2xl border-2 border-safety bg-gradient-to-br from-ink via-navy to-ink p-6 shadow-safety md:p-8"
      >
        {/* Safety stripe accent */}
        <div
          className="absolute inset-x-0 top-0 h-1.5 bg-safety"
          aria-hidden="true"
        />
        <div className="grid items-center gap-6 md:grid-cols-[1fr_auto]">
          <div>
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-safety px-3 py-1 text-[10px] font-bold uppercase tracking-[0.25em] text-ink">
              <Flame className="h-3.5 w-3.5" aria-hidden="true" /> Launch Offer
            </div>
            <h2 className="font-display text-2xl leading-tight tracking-wide text-white sm:text-3xl md:text-4xl">
              Special Launch Offer: Get{" "}
              <span className="text-gradient-gold">15% Off</span> Your Premium Epoxy Floor Coating!
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
              Valid only for the first 20 homeowners in Edmonton.{" "}
              <span className="font-bold text-gold">🚨 Only 17 spots left!</span> Secure your
              estimate today to lock in your discount.
            </p>
          </div>
          <Button
            asChild
            size="lg"
            className="h-14 self-start whitespace-nowrap bg-safety px-7 font-bold uppercase tracking-wider text-ink shadow-safety hover:bg-safety/90 hover:scale-105 transition-transform md:self-center"
          >
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="mr-2 h-5 w-5" /> Claim 15% Off
            </a>
          </Button>
        </div>
      </motion.div>
    </div>
  </section>
);